import { FC, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGElement>

const IconSend: FC<Props> = ({ ...rest }) => {
  return (
    <svg
      width='25'
      height='19'
      viewBox='0 0 25 19'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path d='M24.9234 0.932268L24.7784 1.18087L14.7928 18.2932C14.6685 18.5003 14.3992 18.5418 14.2334 18.3967L7.66614 13.1346L7.68686 12.9689L17.9418 5.30357C18.0661 5.19998 18.1075 5.03425 18.004 4.90994C17.9211 4.78564 17.7346 4.74421 17.6103 4.82708L6.36097 11.9537V11.9952L5.78089 15.9729C5.76017 16.1179 5.57372 16.1179 5.53228 15.9729L4.41356 10.4207L3.56416 9.7163L0.145848 6.94021C-0.102757 6.75376 -0.0198884 6.36014 0.290868 6.27727L21.5259 0.621512L24.2605 0.0207171C24.3019 0 24.3434 0 24.3848 0C24.8406 0.0207171 25.1513 0.517926 24.9234 0.932268Z' />
    </svg>
  )
}

export default IconSend
